import {WsTrusteeSortField} from '@lifeislife/lifeislife-ws-api';


// Export type and value
export type TrusteeSortField = WsTrusteeSortField;
export const TrusteeSortField = WsTrusteeSortField;
